export default (message) => {
    return {
        getElement: function () {
            let div = document.createElement("div");
            div.classList.add("c-iubenda-notice");
            div.innerHTML = '<div class="c-iubenda-notice_content">' + message + '</div>';

            return div;
        },

        appendBefore: function (element) {
            element.parentElement.insertBefore(this.getElement(), element);
        },

        appendInside: function (parent) {
            parent.append(this.getElement());
        },

        observeMutation: function (parent, callback) {
            // Devo creare una istanza di MutationObserver per ogni elemento.
            let observer = new MutationObserver((mutationList, observer) => {
                let lastMutation = null;
                mutationList.forEach(mutation => {
                    if (mutation.type === "childList") {
                        lastMutation = mutation;
                    }
                });

                if (lastMutation) {
                    // Disconnetto l’observer per evitare loop infiniti.
                    observer.disconnect();

                    // Rimuovo il messaggio che invita l’utente ad
                    // accettare i cookie di Iubenda perché non serve più.
                    lastMutation.target.parentElement.querySelector(".c-iubenda-notice")?.remove();

                    // Eseguo l’eventuale callback
                    if (callback) {
                        callback(lastMutation);
                    }
                }
            });

            observer.observe(parent, {
                attributes: true, childList: true, subtree: true
            });
        }
    };
};
